import React from 'react';

export type VersionDependentImage = {
  src: string | { src: string };
  alt: string;
};

export type Props = VersionDependentImage & {
  width?: number | string;
  height?: number | string;
  className?: string;
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement>) => void;
};

export const StaticImage = React.memo((props: Props) => {
  const {
    src,
    alt,
    width,
    height,
    className,
    onLoad,
  } = props;

  return (
    <img
      className={className}
      src={typeof src === 'string' ?
        src : src.src }
      alt={alt}
      width={width}
      height={height}
      onLoad={onLoad}
      loading={onLoad
        ? 'lazy' : 'eager'}
    />
  );
});

StaticImage.displayName = 'StaticImage';
